import { IInternalState } from "./context";
import dayjs from "dayjs";

export const LOADING = "LOADING";
export const SET_OVERALL_STATS = "SET_OVERALL_STATS";
export const SET_DRIVERS_STATS = "SET_DRIVERS_STATS";
export const SET_SKIP_HISTORY = "SET_SKIP_HISTORY";
export const SET_REASONS_BREAKDOWN = "SET_REASONS_BREAKDOWN";
export const SET_DRIVERS_QUERY = "SET_DRIVERS_QUERY";
export const SET_HISTORY_QUERY = "SET_HISTORY_QUERY";
export const RESET = "RESET";

// Default date range: last 30 days
const defaultFromDate = dayjs().subtract(30, "days").format("YYYY-MM-DD");
const defaultToDate = dayjs().format("YYYY-MM-DD");

export const initialState: IInternalState = {
  loading: [],
  overallStats: null,
  driversStats: null,
  skipHistory: null,
  reasonsBreakdown: null,
  driversQuery: {
    page: 1,
    per_page: 10,
    keyword: "",
    from_date: defaultFromDate,
    to_date: defaultToDate,
  },
  historyQuery: {
    page: 1,
    per_page: 10,
    from_date: defaultFromDate,
    to_date: defaultToDate,
  },
};

const SkipAnalyticsReducer = (state: IInternalState, action: any): IInternalState => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.payload };
    case SET_OVERALL_STATS:
      return { ...state, overallStats: action.payload };
    case SET_DRIVERS_STATS:
      return { ...state, driversStats: action.payload };
    case SET_SKIP_HISTORY:
      return { ...state, skipHistory: action.payload };
    case SET_REASONS_BREAKDOWN:
      return { ...state, reasonsBreakdown: action.payload };
    case SET_DRIVERS_QUERY:
      return { ...state, driversQuery: action.payload };
    case SET_HISTORY_QUERY:
      return { ...state, historyQuery: action.payload };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default SkipAnalyticsReducer;
